import { gql } from "@apollo/client";

const DELETE_TOR_COMPONENT_TABLE_C = gql`
    mutation deleteToRComponentTableC($torID: String!, $laID: String!, $componentID: String!){
      deleteToRComponentTableC(torID: $torID, laID: $laID, componentID: $componentID) 
  }
`;

export default DELETE_TOR_COMPONENT_TABLE_C;
